import React from 'react';
import { StyledDiv } from './trofeoBanner.styles';

const TROFEO_BASE_URL = 'https://trofeo.live/';

interface ITrofeoCopy {
	eyebrow: string;
	title: string;
	text: string;
	buttonText: string;
}

/**
 * Per-article copy. Each entry frames Trofeo.live as the natural next step for that
 * article's angle (product pick, format, predictions, pool how-to) so the banner
 * reads as a recommendation rather than an ad. Falls back to DEFAULT_COPY.
 */
const COPY_BY_SLUG: Record<string, ITrofeoCopy> = {
	'the-best-brackets-maker-for-the-fifa-world-cup': {
		eyebrow: 'Create your bracket pool',
		title: 'Turn your World Cup bracket into a live prediction pool',
		text: 'Trofeo.live lets you invite friends, lock in picks before kickoff, and watch the leaderboard update automatically from the group stage to the final. Free for up to 50 players, no betting, just bragging rights.',
		buttonText: 'Start a Pool',
	},
	'fifa-world-cup-bracket-format-explained': {
		eyebrow: 'Put the format to work',
		title: 'Now predict the whole tournament with friends',
		text: 'Once you know the format, Trofeo.live makes it a game: pick your group winners and knockout results, then track who called it right on a live leaderboard. Free for up to 50 players, no betting involved.',
		buttonText: 'Create a Pool',
	},
	'fifa-world-cup-predictions-contenders-dark-horses': {
		eyebrow: 'Back your picks',
		title: 'Think you can call the winner? Prove it.',
		text: 'Put your contenders and dark horses on the line in a Trofeo.live prediction pool. Invite your friends, lock in before the first whistle, and let the live leaderboard settle the debate. Free, no betting.',
		buttonText: 'Create a Pool',
	},
	'how-to-run-a-fifa-world-cup-bracket-pool': {
		eyebrow: 'The easy way',
		title: 'Skip the spreadsheet, run your pool on Trofeo',
		text: 'Trofeo.live handles the invites, picks, scoring, and standings for you, with automatic updates as results come in and reminders on WhatsApp, Slack, Telegram or email. Free for up to 50 players, no betting.',
		buttonText: 'Start for Free',
	},
	'vertical/international/world-cup-bracket': {
		eyebrow: 'Create your bracket pool',
		title: 'Turn your World Cup bracket into a live prediction pool',
		text: 'Trofeo.live lets you invite friends, lock in picks before kickoff, and watch the leaderboard update automatically from the group stage to the final. Free for up to 50 players, no betting, just bragging rights.',
		buttonText: 'Start a Pool',
	},
};

const DEFAULT_COPY: ITrofeoCopy = {
	eyebrow: 'Run it as a pool',
	title: 'Make the 2026 World Cup a friendly competition',
	text: 'Trofeo.live turns the tournament into a live prediction pool: invite friends, lock in your picks, and watch the leaderboard update automatically. Free for up to 50 players, no betting, just bragging rights.',
	buttonText: 'Start a pool',
};

export const TrofeoBanner = ({ slug }: { slug: string }) => {
	const copy = COPY_BY_SLUG[slug] || DEFAULT_COPY;
	const href = `${TROFEO_BASE_URL}?utm_source=bracketsninja&utm_medium=blog_banner&utm_campaign=fifa_world_cup&utm_content=${slug}`;

	return (
		<StyledDiv>
			<div className="trofeo-head">
				<div className="trofeo-icon" aria-hidden="true">
					🏆
				</div>
				<div className="trofeo-copy">
					<span className="eyebrow">{copy.eyebrow}</span>
					<h3>{copy.title}</h3>
					<p>{copy.text}</p>
				</div>
			</div>
			<a
				className="trofeo-cta"
				href={href}
				target="_blank"
				rel="noopener noreferrer"
			>
				{copy.buttonText}
			</a>
		</StyledDiv>
	);
};
